import { CONFIG } from '../../../core/config';
import { RiskMatrixVector } from './risk-matrix-vector';

export class RiskMatrixConsequenceVector implements RiskMatrixVector {
  readonly friendlyTypeNameSingular = 'Risk Matrix Consequence Vector';
  readonly apiRoute: string = CONFIG.apiRoutes.riskMatrixConsequenceVectors;

  riskMatrixConsequenceVectorId: string;
  index: number;
  label: string;

  get id(): string {
    return this.riskMatrixConsequenceVectorId;
  }

  riskMatrixId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.riskMatrixConsequenceVectorId = data.riskMatrixConsequenceVectorId;
    this.index = data.index;
    this.label = data.label;
    this.riskMatrixId = data.riskMatrixId;
  }
}
